import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { getAllowedRoutes } from "@/utils/permissions";
import { useMemo } from "react";
import { matchPath, Navigate, useLocation } from "react-router-dom";

export const RoleGuard: FCC = ({ children }) => {
  const { userType } = useInitSetup();
  const { pathname } = useLocation();

  const isAllowed = useMemo(() => {
    if (!userType) return true;

    const allowedRoutes = getAllowedRoutes(userType);
    return allowedRoutes.length === 0 || allowedRoutes.some((route) => matchPath(route, pathname));
  }, [userType, pathname]);

  if (!isAllowed) {
    return <Navigate to={AppRoutes.home} replace />;
  }

  return <>{children}</>;
};
